
import React from 'react';
import { Link } from 'react-router-dom';
import styles from './Header.module.scss';
const Header = () => {
  return (
    <header>
      <h1>Apprentissage des mots français</h1>
     
    </header>
  );
};

export default Header;
